<template>
    <div class="contact-explore">
        <div class="contact-explore-header">
            <router-link class="contact-explore-header__close-btn-link" to="/contact">
                <img class="contact-explore-header__close-btn" src="/assets/imgs/close.png" alt="Close">
            </router-link>

            <ul class="contact-explore-header__anchor-list">
                <li class="contact-explore-header__anchor-item">
                    <router-link class="contact-explore-header__anchor-btn" to="/contact/be-a-hunter/openings">Current Openings</router-link>
                </li>

                <li class="contact-explore-header__anchor-item">
                    <router-link class="contact-explore-header__anchor-btn" to="/contact/be-a-hunter/internships">Internships</router-link>
                </li>
            </ul>

            <div class="contact-explore-header__carousel-container">
                <ul class="contact-explore-header__carousel">
                    <li v-for="beAHunterImage in beAHunterImageArray" class="carousel-cell">

                        <picture>
                            <source media="(max-width: 640px)" :srcset=beAHunterImage.imageMobile>
                            <source media="(min-width: 641px)" :srcset=beAHunterImage.image>
                            <img class="contact-explore-header__carousel-image" :src=beAHunterImage.image :alt=beAHunterImage.imageAltText>
                        </picture>
                        
                    </li>
                </ul>
            </div>
        </div>
  
        <div class="contact-explore-about">
            <h2 class="contact-explore-about__heading">Want to be a HUNTER?</h2>
            <h3 class="contact-explore-about__sub-heading">We’re always on the hunt for the greatest talent to join our team, from interns to SVPs.</h3>
            
            <p class="contact-explore-about__paragraph">Recently named Consumer Agency of the Year and one of PRovoke Media’s “Best Places To Work,” HUNTER offers employees hybrid work environments and a “work from anywhere” policy (up to four weeks per year), competitive benefits including medical, dental &amp; vision, commuter transit benefits, a 401K company match and generous PTO.  Add in perks like regular Cupcakes &amp; Cocktails events, a year-round staff training curriculum,  cultural committees including our Anti-Racism Action Group and Health &amp; Wellness team, epic Halloween parties and more, and you’ve got a recipe for an awesome place to work.</p>

            <p class="contact-explore-about__paragraph">Explore and apply to our current job openings below, or drop us an email at: <a href="mailto:jobs@hunterpr.com" target="_blank">jobs@hunterpr.com</a> and include your resume and cover letter. And don’t forget to visit us on <a href="https://www.linkedin.com/company/hunterny/jobs/">LinkedIn</a> where our opportunities are more regularly updated.</p>
        </div>

        <div id="openings" class="contact-explore-openings">
            <h2 class="contact-explore-openings__heading">Current Openings</h2>

            <ul class="contact-explore-openings__list">
                Visit LinkedIn for a full list of HUNTER job openings
                <li v-for="opening in openingsDataArray" class="contact-explore-openings__item">
                    <div class="contact-explore-openings__header-container" v-on:click=onOpeningClick>
                        <h2 class="contact-explore-openings__header-heading" v-html=opening.title></h2>
                        <h3 class="contact-explore-openings__header-location">Location: {{opening.location}}</h3>
                    </div>

                    <div class="contact-explore-openings__body-container">
                        <div class="contact-explore-openings__body-wrapper">
                            <div class="contact-explore-openings__body-copy" v-html=opening.description></div>
                            <a class="contact-explore-openings__body-apply-btn" :href=opening.applyLink target="_blank">Apply Now</a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div id="internships" class="contact-explore-internship">
            <div class="contact-explore-internship__wrapper">
                <h2 class="contact-explore-internship__heading">Ready to Earn It?  Apply to the HUNTER Summer 2026 Internship Program!</h2>
                
                <p class="contact-explore-internship__paragraph">Are you a rising senior in college ready to brush up your PR and marketing communications skills who is searching for the perfect paid summer internship?  Our interns are placed on teams across the agency’s business and specialty departments, including Food + Beverage, Financial + Corporate Services, Health + Beauty, Lifestyle, Tech, Travel + Hospitality, Home,  Digital + Influencer, Creative Services, Media + Entertainment and more.</p>

                <p class="contact-explore-internship__paragraph">Our interns are integrated into the agency’s teams and have learning experiences including:</p>
                <ul class="contact-explore-internship__list">           
                    <li class="contact-explore-internship__item">Media outreach</li>
                    <li class="contact-explore-internship__item">Monitoring, measuring and tracking coverage</li>
                    <li class="contact-explore-internship__item">Social &amp; digital campaigns</li>
                    <li class="contact-explore-internship__item">Influencer relations</li>
                    <li class="contact-explore-internship__item">Integrations &amp; partnerships</li>
                    <li class="contact-explore-internship__item">Content development</li>
                    <li class="contact-explore-internship__item">Event activations</li>
                    <li class="contact-explore-internship__item">Brainstorming &amp; research</li>
                </ul>

                <p class="contact-explore-internship__paragraph">To be considered, students must:</p>
                  <ul class="contact-explore-internship__list">
                    <li class="contact-explore-internship__item">Be a rising senior in a college or university program</li>
                    <li class="contact-explore-internship__item">Understand PR and marketing communications at a basic level </li>
                    <li class="contact-explore-internship__item">Possess solid writing and communication skills</li>
                    <li class="contact-explore-internship__item">Have a positive, inquisitive, proactive attitude</li>
                    <li class="contact-explore-internship__item">PRSSA membership or involvement is always a plus, but not required.</li>
                  </ul>

              <p class="contact-explore-internship__paragraph--disclaimer">
                The Summer 2026 Internship Program will be in-person operating on a hybrid schedule at our New York City headquarters office. <br>&nbsp;<br>
              </p>

              <p class="contact-explore-internship__paragraph--disclaimer">
                In order to comply with equal pay and salary transparency laws in various locations, the Company believes the target base compensation for this role is $20/hour. Actual compensation is influenced by a wide array of factors including, but not limited to skill set, level of experience and location.  Interns are responsible for arranging and securing their own housing accommodations within a commutable distance from NYC.
              </p>
              
                <h3 class="contact-explore-internship__sub-heading--dark">APPLY:</h3>

                <p class="contact-explore-internship__paragraph">
                  To apply, please send your resume and cover letter to <a href="mailto:internship@hunterpr.com">internship@hunterpr.com</a>
                </p>

                <ul class="contact-explore-internship__date-list">
                    <li class="contact-explore-internship__date-item">
                        <h4 class="contact-explore-internship__date-heading">Internship Period*</h4>
                        <p class="contact-explore-internship__date">Summer (June 2026 – August 2026)</p>
                    </li>

                    <li class="contact-explore-internship__date-item">
                        <h4 class="contact-explore-internship__date-heading">Deadline to Submit</h4>
                        <p class="contact-explore-internship__date">February 2, 2026</p>
                    </li>

                  <li class="contact-explore-internship__date-item">
                    <h4 class="contact-explore-internship__date-heading">Interview Period</h4>
                    <p class="contact-explore-internship__date">February 9 – March 13, 2026</p>
                  </li>
                  
                    <li class="contact-explore-internship__date-item">
                        <h4 class="contact-explore-internship__date-heading">Notification of Selected Interns*</h4>
                        <p class="contact-explore-internship__date">Mid to late March 2026</p>
                    </li>
                </ul>

                <div class="contact-explore-internship__date-disclaimer">*Approximate Dates</div>
               
 
                <div class="contact-explore-internship__divider"></div>

                <h3 class="contact-explore-internship__tour-heading">Does your school want to take a virtual tour of HUNTER?</h3>

                <p class="contact-explore-internship__paragraph">
                  Please send requests for school group tour information to <a href="mailto:internship@hunterpr.com" target="_blank">internship@hunterpr.com</a>.
                </p>

                <div class="contact-explore-internship__divider"></div>

            </div>
        </div>
  
        <div class="contact-explore-footer">
            <h2 class="contact-explore-footer__heading">Learn more...</h2>
            <div class="contact-explore-footer__link-container">
                <a href="/work/case-studies" class="contact-explore-footer__link">Work</a>
                <a href="/expertise/explore" class="contact-explore-footer__link">Expertise</a>
            </div>
        </div>
    </div>
</template>

<style scoped lang="less">
    @import "../less/breakpoints.less";

    .contact-explore {
        background-color: #003a4a;
        color: #ffffff;
        position: relative;
    }
    
    .contact-explore-header__anchor-list {
        margin: 0;
        padding: 0;
        position: absolute;
        text-align: center;
        top: 80px;
        width: 100%;
        z-index: 10;
    }

    .contact-explore-header__anchor-item {
        display: inline-block;
        padding: 0 15px;

        @media @breakpoint__tablet--small {
            padding: 0 5px;
        }

        &:nth-child(2) {
            border-left: solid 2px #e40046;
        }
    }

    .contact-explore-header__anchor-btn {
        background: none;
        border: none;
        color: #ffffff;
        cursor: pointer;
        font-family: Flama, Arial, Helvetica, sans-serif;
        font-size: 18px;
        letter-spacing: 0.3px;
        text-decoration: none;
        text-transform: uppercase;

        @media @breakpoint__tablet--small {
            font-size: 14px;
        }
    }

    .contact-explore-header__carousel-container {
        position: relative;

        @media @breakpoint__tablet--small {
            //height: 50vh;
        }
    }

    .contact-explore-header__carousel {
        margin: 0;
        padding: 0;
    }

    .carousel-cell {
        font-size: 0;
        overflow: hidden;
        width: 100%;

        &:after {
            background-color: #000000;
            content: "";
            height: 100%;
            left: 0;
            opacity: 0.4;
            position: absolute;
            top: 0;
            width: 100%;
        }
    }

    .contact-explore-header__carousel-image {
        display: flex;
        position: relative;
        width: 100%;

        @media @breakpoint__tablet--small {
            //height: 50vh;
            //left: -50%;
            //width: auto;
        }
    }

    .contact-explore-header__close-btn-link {
        display: block;
        left: 25px;
        position: absolute;
        top: 20px;
        z-index: 100;

        @media @breakpoint__mobile--large {
            left: 15px;
        }
    }

    .contact-explore-header__close-btn {
        cursor: pointer;
        display: block;
        width: 49px;
        z-index: 70;

        @media @breakpoint__mobile--large {
            width: 36px;
        }
    }

    .contact-explore-header {
        height: 0;
        overflow: hidden;
        position:relative;
        width:100%;
    }

    .contact-explore-header__content {
        box-sizing: border-box;
        left: 0;
        margin: auto;
        max-width: 1300px;
        padding: 0 50px;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        z-index: 10;

        @media @breakpoint__mobile--large {
            box-sizing: border-box;
            left: 0;
            padding: 0 50px;
            top: 40%;
            width: 100%;

        }
    }

    .contact-explore-header__heading {
        color: #ffffff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 40px;
        line-height: 1.2;
        margin: 0 0 30px;
        max-width: 700px;
        opacity: 0;
        padding-bottom: 70px;
        position: relative;
        transform: translateY(20px);

        &:after {
            bottom: 0;
            content: "";
            border-bottom: 4px solid red;
            position: absolute;
            left: 0;
            width: 150px;
        }

        @media @breakpoint__mobile--large {
            font-size: 32px;
        }

        @media @breakpoint__tablet--medium {
            font-size: 26px;
        }
    }

    .contact-explore-header__paragraph {
        font-size: 22px;
        line-height: 1.4;
        margin: 0 0 30px;
        opacity: 0;
        transform: translateY(20px);
        width: 700px;

        @media @breakpoint__tablet--large {
            font-size: 20px;
            width: 420px;
        }

        @media @breakpoint__tablet--medium {
            font-size: 14px;
            width: 275px;
        }

        @media @breakpoint__mobile--large {
            font-size: 14px;
        }
    }

    .contact-explore-header__read-more-link-container {
        opacity: 0;
        transform: translateY(20px);
    }

    .contact-explore-header__read-more-link {
        border: 1px solid #ffffff;
        border-radius: 5px;
        color: #ffffff;
        cursor: pointer;
        display: inline-block;
        font-size: 1.1em;
        letter-spacing: 1.2px;
        line-height: 23px;
        margin: 0;
        padding: 3px 5px 2px;
        text-decoration: none;
        text-transform: uppercase;
        transition: 0.5s all;

        &:focus {
            outline: none;
        }

        &:hover {
            background: #ffffff;
            color: #003a4a;
        }

        &.active {
            background: #e40046;
            color: #ffffff;

            &:hover {
                border: 1px solid #e40046;
            }
        }

        &.disabled {
            border: 1px solid #003a4a;
            cursor: default;
            opacity: 0.3;
            
            &:hover {
                background: #ffffff;
                color: #003a4a;
            }
        }
    }

    .contact-explore-header__placeholder-image {
        display: block;
        position: relative;
        width: 100%;
        z-index: 0;

        @media @breakpoint__mobile--large {
            //height: 100%;
            //left: 50%;
            //transform: translateX(-50%);
            //width: auto;
        }
    }

    .contact-explore-about {
        box-sizing: border-box;
        max-width: 1300px;
        margin: 0 auto;
        padding: 60px 50px 0;
        position: relative;
        width: 100%;
        z-index: 10;

        @media @breakpoint__mobile--large {
            padding: 60px 25px 60px;
        }
    }

    .contact-explore-about__heading {
        color: #e40046;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 50px;
        line-height: 1;
        margin: 0 0 20px;
        opacity: 0;
        transform: translateY(-30px);

        @media @breakpoint__mobile--large {
            font-size: 36px;
        }
    }

    .contact-explore-about__sub-heading {
        color: #ffffff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 30px;
        line-height: 1.4;
        margin: 0 0 40px;
        opacity: 0;
        transform: translateY(-30px);

        @media @breakpoint__mobile--large {
            font-size: 26px;
        }
    }

    .contact-explore-about__paragraph {
        color: #fff;
        font-size: 18px;
        letter-spacing: 0.3px;
        line-height: 2;
        margin: 0 0 20px;
        opacity: 0;
        transform: translateY(-30px);

        a {
            color: #e40046;
            text-decoration: none;
        }

        @media @breakpoint__tablet--medium{
            font-size: 15px;
        }
    }

    .contact-explore-openings {
        box-sizing: border-box;
        max-width: 1300px;
        margin: 0 auto;
        opacity: 0;
        padding: 60px 50px 80px;
        position: relative;
        transform: translateY(-30px);
        width: 100%;
        z-index: 10;

        @media @breakpoint__mobile--large {
            padding: 0 25px 80px;
        }
    }
    
    .contact-explore-openings__heading {
        color: #ffffff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 30px;
        margin: 0 0 50px;
        text-transform: uppercase;

        @media @breakpoint__mobile--large {
            font-size: 26px;
        }
    }

    .contact-explore-openings__list {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
    
    .contact-explore-openings__item {
        border-bottom: 0.5px solid #707070;
        margin: 0 0 30px;
    }

    .contact-explore-openings__header-container {
        cursor: pointer;
        margin: 0;
        padding: 0 0 30px 0;
        position: relative;

        &:after {
            content: "+";
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
            font-size: 30px;
            line-height: 1;
            position: absolute;
            right: 20px;
            top: 30%;
            transform: translateY(-50%);
        }

        &.active {
            &:after {
                content: "-";
            }
        }
    }
    
    .contact-explore-openings__header-heading {
        color: #E40046;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 22px;
        margin: 0 0 20px;
        text-transform: uppercase;
        width: 80%;
    }
    
    .contact-explore-openings__header-location {
        color: #ffffff;
        font-size: 22px;
        margin: 0 0 20px;
        width: 80%;
    }
    
    .contact-explore-openings__body-container {
        height: 0;
        overflow: hidden;
    }

    .contact-explore-openings__body-wrapper {
        border-bottom: 1px solid #ffffff;
        margin-bottom: 40px;
    }
    
    .contact-explore-openings__body-copy {
        color: #ffffff;
        font-size: 18px;
        line-height: 2;
        letter-spacing: 0.3px;

        ul {

        }

        li {
            list-style-type: disc;
        }

        @media @breakpoint__mobile--large {
            font-size: 16px;
        }
    }

    .contact-explore-openings__body-apply-btn {
        background: #e40046;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
        display: inline-block;
        font-size: 1em;
        letter-spacing: 1.5px;
        min-width: 110px;
        margin-bottom: 80px;
        padding: 10px;
        text-align: center;
        text-decoration: none;
        z-index: 20;
    }

    .contact-explore-internship {
        background-color: #ffffff;
        border-radius: 150px;
        box-sizing: border-box;
        height: auto;
        opacity: 0;
        padding: 120px 0 120px;
        position: relative;
        transition: 0.3s all;

        @media @breakpoint__tablet--medium {
            border-radius: 100px;
        }

        @media @breakpoint__mobile--large {
            border-radius: 50px;
            padding: 60px 0 60px;
        }
    }

    .contact-explore-internship__wrapper {
        box-sizing: border-box;
        margin: 0 auto;
        max-width: 1300px;
        padding: 0 50px 0;
        width: 100%;

        @media @breakpoint__mobile--large {
            padding: 0 25px 0;
        }
    }

    .contact-explore-internship__heading {
        color: #e40046;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 50px;
        line-height: 1;
        margin: 0 0 40px;

        @media @breakpoint__mobile--large {
            font-size: 36px;
        }
    }

    .contact-explore-internship__sub-heading {
        color: #ffffff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 30px;
        line-height: 1.4;
        margin: 0 0 40px;

        @media @breakpoint__mobile--large {
            font-size: 26px;
        }
    }

    .contact-explore-internship__sub-heading--dark {
        .contact-explore-internship__sub-heading();
        color: #003a4a;
        margin: 60px 0 40px;
    }

    .contact-explore-internship__paragraph {
        color: #003a4a;
        font-size: 18px;
        line-height: 2;
        letter-spacing: 0.3px;
        margin: 0 0 20px;

        a {
            color: #e40046;
            text-decoration: none;
        }

        &:first-of-type {
            max-width: 900px;
        }

        @media @breakpoint__mobile--large {
            font-size: 16px;
        }
    }

    .contact-explore-internship__paragraph--disclaimer {
        .contact-explore-internship__paragraph();
        color: #858585;
        font-style: italic;
        margin-top: 10px;
        width: 80%;
    }

    .contact-explore-internship__list {
        color: #003a4a;
        margin-bottom: 40px;
    }

    .contact-explore-internship__item {
        margin-bottom: 15px
    }

    .contact-explore-internship__date-list {
        margin: 0 0 40px;
        padding: 0;
    }

    .contact-explore-internship__date-item {
        display: inline-block;
        vertical-align: top;
        width: calc(~"100% / 4");

        @media @breakpoint__mobile--large {
            margin-bottom: 40px;
            width: 100%;
        }
    }

    .contact-explore-internship__date-heading {
        color: #003a4a;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 18px;
        margin: 0;
    }

    .contact-explore-internship__date {
        color: #e40046;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 18px;
        text-transform: uppercase;
        margin: 0;
    }

    .contact-explore-internship__date-disclaimer {
        color: #868686;
        font-size: 16px;
        margin-bottom: 50px;
    }

    .contact-explore-internship__apply-link {
        background: #e40046;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
        display: inline-block;
        font-size: 1em;
        letter-spacing: 1.5px;
        min-width: 110px;
        padding: 10px;
        text-align: center;
        text-decoration: none;
        z-index: 20;
    }

    .contact-explore-internship__divider {
        border-bottom: 1px solid #707070;
        margin: 60px 0 60px;
    }

    .contact-explore-internship__tour-heading {
        color: #003a4a;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 18px;
        margin: 0 0 20px;
    }

    .contact-explore-footer {
        background: #003a4a;
        opacity: 0;
        padding: 60px 20px;
    }

    .contact-explore-footer__heading {
        color: #ffffff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 1.8em;
        letter-spacing: 1px;
        line-height: 1;
        margin: 0 0 20px 0;
        text-align: center;
    }

    .contact-explore-footer__link-container {
        display: block;
        text-align: center;
    }

    .contact-explore-footer__link {
        background-color: #e40046;
        border: none;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
        display: inline-block;
        font-size: 16px;
        letter-spacing: 1px;
        padding: 10px 30px;
        text-decoration: none;
        z-index: 20;

        &:first-child {
            margin-right: 30px;

            @media @breakpoint__mobile--small {
                display: table;
                margin: 0 auto 20px;
            }
        }
    }
</style>


<style lang="less">

    .flickity-viewport {
        max-height: 90vh;
    }

    .flickity-page-dots {
        bottom: 25px;
        color: #ffffff;

        .dot {
            background: #ffffff;
            opacity: 1;

            &.is-selected {
                background: #e40046;
            }
        }
    }

    .flickity-button {
        background: transparent;
        border-radius: 0;
        opacity: 1;
        transition: all 0.3s;

        &:hover {
            background: none;
            opacity: 1;
        }

        &:disabled {
            display: none;
        }
    }

    .flickity-prev-next-button {
        padding: 0;

        &.previous {
            left: 1.5vw;
        }

        &.next {
            right: 1.5vw;
        }

        .flickity-button-icon {
            fill: #ffffff;
            position: relative;
            left: auto;
            top: auto;
            width: 100%;
            height: 100%;
            transition: all 0.3s;

            &:hover {
                fill: #e40046;
            }
        }

        .global-carousel--dark & {
            .flickity-button-icon {
                fill: #333333;
            }
        }
    }

    .contact-explore-openings__body-copy {
        color: #ffffff;
        font-size: 18px;
        line-height: 2;
        margin-bottom: 40px;

        ul {

        }

        li {
            list-style-type: disc;
        }
    }
</style>


<script>
    export default {
        name: "ContactExplore",
        data: function()
        {
            return {
                beAHunterImageArray : [],
                openingsDataArray : []
            }
        },
        created : function()
        {
            var vm = this;
            var testIfDataLoaded = setInterval(function()
            {
                if (!vm.isObjectEmpty(vm.$parent.modelSeo))
                {
                    clearInterval(testIfDataLoaded);
                    vm.initOpenings(vm.$parent.modelOpenings);
                    vm.initBeAHunter(vm.$parent.modelBeAHunter);
                    vm.initAnimIn();
                    vm.initSubTitle();

                    if (vm.$route.params.anchor)
                    {
                        setTimeout(function()
                        {
                            vm.onRouteChange(vm.$route.params.anchor);
                        }, 1000);

                    }
                }
            }, 500);
        },
        mounted: function()
        {
            TweenMax.to(".header__logo-sub-title-container", 0.2, {width: 0});
        },
        methods: {
            initBeAHunter : function(data)
            {
                for (var i = 0; i < data.length; i++)
                {
                    var hunterImage = {};
                    hunterImage.image = data[i].Image;
                    hunterImage.imageMobile = data[i].ImageMobile;
                    hunterImage.imageAltText = data[i].ImageAltText;
                    this.beAHunterImageArray.push(hunterImage);
                }

            },
            initOpenings : function(data)
            {
                for (var i = 0; i < data.length; i++) {
                    var opening = {};
                    opening.title = data[i].Title;
                    opening.location = data[i].Location;
                    opening.description = data[i].Description;
                    opening.applyLink = "mailto:jobs@hunterpr.com?subject=" + data[i].Subject;
                    this.openingsDataArray.push(opening);
                }

                var vm = this;
                setTimeout(function()
                        {
                            vm.initCarousel();
                        }, 1000);

                
            },
            initCarousel : function() 
            {
                var flickitySettings = {
                    "cellAlign": "left",
                    "contain" : true,
                    "groupCells" : true,
                    "imagesLoaded" : true,
                    "pageDots" : true,
                    "arrowShape": {
                        "x0": 20,
                        "x1": 60, "y1": 45,
                        "x2": 65, "y2": 40,
                        "x3": 30
                    }
                };

                var flkty = new Flickity('.contact-explore-header__carousel', flickitySettings);
            },
            onRouteChange : function(anchor)
            {
                TweenMax.to(window, 1.6, {scrollTo:{y: "#" + anchor}, autoKill: false, ease: Power4.easeInOut});
            },
            onOpeningClick : function(e)
            {
                if (e.currentTarget.classList.contains("active"))
                {
                    TweenMax.set(e.currentTarget, {className: '-=active'});
                    TweenMax.to(e.currentTarget.nextSibling, 0.6, {height: 0});
                }
                else
                {
                    TweenMax.set(".contact-explore-openings__header-container", {className: '-=active'});
                    var wrapperHeight = e.currentTarget.nextSibling.querySelector(".contact-explore-openings__body-wrapper").offsetHeight  + "px";
                    TweenMax.set(e.currentTarget, {className: '+=active'});
                    TweenMax.to(".contact-explore-openings__body-container", 0.4, {height: 0});
                    TweenMax.to(e.currentTarget.nextSibling, 0.6, {height: wrapperHeight});
                }
            },
            initAnimIn : function()
            {
                TweenMax.set(".contact-explore-header", {height:"auto"});
                TweenMax.from(".contact-explore-header", 0.6, {height:0, ease: Power2.easeOut, delay: 0.2});

                var tl = new TimelineMax();
                tl.to(".contact-explore-about__heading", 0.5, {transform: "translateY(0)", opacity: 1}, "+=0.8");
                tl.to(".contact-explore-about__sub-heading", 0.5, {transform: "translateY(0)", opacity: 1}, "-=0.3");
                tl.to(".contact-explore-about__paragraph", 0.5, {transform: "translateY(0)", opacity: 1}, "-=0.3");
                tl.to(".contact-explore-openings", 0.5, {transform: "translateY(0)", opacity: 1}, "-=0.2");
                tl.to(".contact-explore-internship", 0.5, {transform: "translateY(0)", opacity: 1}, "-=0.2");
                tl.to(".contact-explore-footer", 0.5, {opacity: 1}, "-=0.2");
            },
            initSubTitle : function() {
                document.querySelector(".header__logo-sub-title").innerHTML = "Be&nbsp;a&nbsp;Hunter";
                TweenMax.set(document.querySelector(".header__logo-sub-title-container"), {width: "auto"});
                TweenMax.from(document.querySelector(".header__logo-sub-title-container"), 0.3, {width: 0, delay: 0.2});
            }
        },
        watch:
        {
            '$route' (to, from)
            {
                this.onRouteChange(this.$route.params.anchor);
            }
        }
    };
</script>
